import CatalogueD8 from "./CatalogueD8";

export default CatalogueD8;